import * as React from 'react';
import { Message } from 'botframework-directlinejs';
import { Feedback01View } from './Feedback01';
import { Feedback02View } from './Feedback02';
import { Feedback03View } from './Feedback03';


export interface FeedbackProps {
    message: Message;
    feedbackMode: string;
    candidates: string[];
    onShow: () => void;
    onCardAction: (type: string, value: string) => void;
    userDefined: any;
}

export interface FeedbackState {
    feedbackEntitiy: any;
}

export class FeedbackView extends React.Component<FeedbackProps,FeedbackState > {

    constructor(props: FeedbackProps,state: FeedbackState) {
        super(props);

        this.state = {
          feedbackEntitiy : (this.props.message.entities || []).find((x) => x.feedback)
        }
    }

    render() {

        if (!this.state.feedbackEntitiy) {
            return null;
        }

       const feedbackComponent = (() =>{
            switch (this.
                props.feedbackMode ){

                case 'f01':
                   return <Feedback01View
                            message={ this.props.message }
                            onCardAction={ this.props.onCardAction }
                            userDefined={ this.props.userDefined }
                        />;
                case 'f02' :
                    return <Feedback02View
                            message={ this.props.message }
                            candidates={ this.props.candidates }
                            onCardAction={ this.props.onCardAction }
                            userDefined={ this.props.userDefined }
                        />;
                 case 'f03' :
                    return <Feedback03View
                            message={ this.props.message }
                            onCardAction={ this.props.onCardAction }
                            onShow={ this.props.onShow }
                            userDefined={ this.props.userDefined }
                        />;
                default:

            }
        })();

        return (
            <div>
            {feedbackComponent}
            </div>
        );
   }

}


// WEBPACK FOOTER //
// ./src/Feedback.tsx